import { useIntl } from 'react-intl';

import type { ChargingStop } from '#domain/ChargingStop.ts';
import type { RoutingSettings } from '#features/tourCreate/model/routingSettings.ts';
import { EV_DEMO_PROFILE } from '#features/tourCreate/service/smartRoute.ts';

export const EvChargingPreview = ({
    stops,
    settings,
    chargingDuration,
}: {
    stops: ChargingStop[];
    settings?: RoutingSettings;
    chargingDuration?: number;
}) => {
    const intl = useIntl();
    return (
        <div className='margin-top-10'>
            <div className='text-size-12'>
                {intl.formatMessage({
                    id: settings
                        ? 'intl-msg:ordercom-cloud-frontend.routing-settings.assumptions'
                        : 'intl-msg:ordercom-cloud-frontend.smart-route.ev-disclaimer',
                })}
            </div>
            <div className='margin-top-5'>
                {intl.formatMessage(
                    { id: 'intl-msg:ordercom-cloud-frontend.smart-route.ev-summary' },
                    {
                        count: stops.length,
                        minutes: Math.ceil(stops.reduce((sum, stop) => sum + stop.duration, 0) / 60),
                    }
                )}
            </div>
            {chargingDuration !== undefined && (
                <p className='margin-top-5'>
                    {intl.formatMessage(
                        { id: 'intl-msg:ordercom-cloud-frontend.routing-settings.chargingTotal' },
                        { minutes: Math.ceil(chargingDuration / 60) }
                    )}
                </p>
            )}
            {!settings && stops.length > 0 && (
                <ol className='margin-top-5 margin-bottom-0 padding-left-20 overflow-auto' style={{ maxHeight: 160 }}>
                    {stops.map((stop, index) => (
                        <li key={stop.id}>
                            {stop.name && <strong>{stop.name}: </strong>}
                            {intl.formatMessage(
                                { id: 'intl-msg:ordercom-cloud-frontend.smart-route.ev-stop' },
                                {
                                    number: index + 1,
                                    minutes: Math.ceil(stop.duration / 60),
                                    arrival: Math.round((stop.arrivalCharge / EV_DEMO_PROFILE.maxCharge) * 100),
                                    departure: Math.round((stop.targetCharge / EV_DEMO_PROFILE.maxCharge) * 100),
                                }
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </div>
    );
};
